module.exports = __webpack_public_path__ + "static/img/like.d332084d.png";